// extracted by mini-css-extract-plugin
module.exports = {"container":"pageview_container__ggN_d","title":"pageview_title__Qz9rt","content":"pageview_content__118Ie"};